import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { AutoBrokerSection } from '../components/AutoBrokerSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { StepsSection } from '../components/StepsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { LeadCaptureSection } from '../components/LeadCaptureSection';
import { FooterSection } from '../components/FooterSection';
import { WhatsAppButton } from '../components/WhatsAppButton';
interface MainPageProps {
  language: 'en' | 'es';
  toggleLanguage: () => void;
}
export function MainPage({
  language,
  toggleLanguage
}: MainPageProps) {
  return <div className="relative overflow-hidden" data-id="element-318">
      <Navbar language={language} toggleLanguage={toggleLanguage} data-id="element-319" />

      <main data-id="element-320">
        <HeroSection language={language} data-id="element-321" />

        {/* Luxury Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-322" />

        <ServicesSection language={language} data-id="element-323" />

        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-324" />

        <AutoBrokerSection language={language} data-id="element-325" />

        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-326" />

        <ComparisonSection language={language} data-id="element-327" />

        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-328" />

        <StepsSection language={language} data-id="element-329" />

        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-330" />

        <TestimonialsSection language={language} data-id="element-331" />

        <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent my-0" data-id="element-332" />

        <LeadCaptureSection language={language} data-id="element-333" />
      </main>

      <FooterSection language={language} data-id="element-334" />

      <WhatsAppButton data-id="element-335" />
    </div>;
}